export default __webpack_public_path__ + "static/media/cleaner-p-800.5eb44ed7.png";